/*
  Magic Grip · autoplay de videos (SISTEMA.md sección 7.2).
  Todo <video data-mg-autoplay muted loop playsinline preload="none" poster="..."> se reproduce
  solo cuando está en pantalla y la pestaña está activa. Con prefers-reduced-motion queda en poster.
  Las fuentes pueden ir en data-src (en el <video> o en sus <source>) para no pedirlas antes de tiempo.
*/
(function () {
  if (window.MGAutoplay) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var visible = new Set();
  var io = null;
  var near = null;

  function load(video) {
    if (video.dataset.mgLoaded) return;
    video.dataset.mgLoaded = '1';
    var changed = false;
    if (video.dataset.src && !video.src) { video.src = video.dataset.src; changed = true; }
    video.querySelectorAll('source[data-src]').forEach(function (s) {
      if (!s.src) { s.src = s.dataset.src; changed = true; }
    });
    if (changed) video.load();
  }

  function play(video) {
    if (reduce.matches || document.hidden || video.dataset.mgPaused === '1') return;
    load(video);
    video.muted = video.dataset.mgSound !== '1';
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  }

  function onIntersect(entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { visible.add(e.target); play(e.target); }
      else { visible.delete(e.target); e.target.pause(); }
    });
  }

  function scan(root) {
    if (!('IntersectionObserver' in window)) return;
    if (!io) io = new IntersectionObserver(onIntersect, { threshold: 0.35 });
    /* Pide el archivo media pantalla antes de que el video entre, para que arranque al llegar */
    if (!near) near = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting && !reduce.matches) { load(e.target); near.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px 50% 0px' });
    (root || document).querySelectorAll('video[data-mg-autoplay]:not([data-mg-bound])').forEach(function (v) {
      v.dataset.mgBound = '1';
      v.muted = true;
      v.setAttribute('playsinline', '');
      io.observe(v);
      near.observe(v);
    });
  }

  document.addEventListener('visibilitychange', function () {
    visible.forEach(function (v) { if (document.hidden) v.pause(); else play(v); });
  });
  if (reduce.addEventListener) {
    reduce.addEventListener('change', function () {
      visible.forEach(function (v) { if (reduce.matches) v.pause(); else play(v); });
    });
  }
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });

  window.MGAutoplay = { scan: scan };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();
})();
